<div class="text-center">
    <div class="title">
        <img src="/assets/images/brand.svg" alt="" width="200">
        <h4>Ingres&aacute;</h4>

        <div class="dotstyle dotstyle-fillup">
            <ul>
                <li class="current"><a></a></li>
                <li><a></a></li>
                <li><a></a></li>
                <li><a></a></li>
                <li><a></a></li>
                <li><a></a></li>
            </ul>
        </div>

        <div class="row m-0">
            <div class="col-md-6">
                <div class="card signup float-right bounceInUp animated">
                    <div class="card-body">
                        <div class="circle-gray circle-lg"><i class="fa fa-user"></i></div>
                        <h6 class="mb-4 mt-2">Representante Vecinal</h6>
                        <a [routerLink]="'/register/nrepresentative'" class="btn btn-success btn-lg">Registrarme</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card signup float-left bounceInUp animated">
                    <div class="card-body">
                        <div class="circle-gray circle-lg"><i class="fa fa-industry"></i></div>
                        <h6 class="mb-4 mt-2">Empresa Contratista</h6>
                        <a [routerLink]="'/register/contractor'" class="btn btn-success btn-lg">Registrarme</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>